import {
	createApp
} from 'vue';

import App from './App.vue'
//element ui
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/theme-chalk/index.css'

import 'element-plus/es/components/message/style/css'
import {
	ElMessageBox
} from 'element-plus'

import $ from 'jquery';

import http from './utils/request.js';
import baseUrl from './utils/baseUrl.js';
import router from './router';
import toast from "./components/toast/toast.js";
import common from "./utils/common.js"

import nodata from '@/views/inc/nodata.vue'; //无内容提示
import top from '@/views/inc/top.vue';
import nav from '@/views/inc/nav.vue';
import head from '@/views/inc/head.vue';
import foot from '@/views/inc/foot.vue';
import banner from '@/views/inc/ind_ban.vue';
import loading from '@/views/inc/loading.vue';
import nban from '@/views/inc/n_ban.vue';
import tanchuang from '@/views/inc/pf_tanchuang.vue';


import pagination from '@/views/inc/pagination.vue'; //分页

const app = createApp(App)
// 设置全局配置，关闭警告信息
app.config.warnHandler = function(msg, vm, trace) {

}
//创建事件总线
app.config.globalProperties.$baseUrl = baseUrl.BASEURL
app.config.globalProperties.$toast = toast;
app.config.globalProperties.$common = common;
app.config.globalProperties.$elMessageBox = ElMessageBox


// 注册全局组件
app.component('no-data', nodata);
app.component('top', top);
app.component('head-nav', nav);
app.component('head-con', head);
app.component('foot', foot);
app.component('banner', banner);
app.component('loading', loading);
app.component('nban', nban);
app.component('tanchuang', tanchuang);
app.component('pagination', pagination);

router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
});

// app.use(store)
app.use(http)
app.use(ElementPlus, {
	locale: zhCn,
})
app.use(router)
app.mount('#container')